import { PRODUCT_LISTING_URL_MATCHER } from '@spartacus/storefront';
import { RoutesConfig } from '@spartacus/core';

import { PRODUCT_DETAILS_URL_MATCHER } from '../url-matchers/product-details-url';
import { RECIPE_CATEGORY_URL_MATCHER } from '../url-matchers/recipe-url.matcher';
import { sisCategoryMatcher } from '../url-matchers/sis-category.matcher';

export const routesConfig: RoutesConfig = {
  forgotPassword: { disabled: true },
  resetPassword: { disabled: true },
  checkoutLogin: { disabled: true },
  register: { disabled: true },
  logout: { disabled: true },

  orderPendingConfirmation: { paths: ['received-order-confirmation/:orderCode'] },
  guestOrderConfirmation: { paths: ['guest-checkout/order/:orderCode'] },
  checkoutPayment: { paths: ['checkout/multi/choose-payment-method'] },
  checkoutDeliveryMode: { paths: ['checkout/multi/choose-delivery'] },
  orderConfirmation: { paths: ['order-confirmation/:orderCode'] },
  orderSummaryReview: { paths: ['order-summary-review'] },
  donations: { paths: ['donations/:orderCode'] },
  orders: { paths: ['my-orders'] },

  login: {
    paths: ['?login=true'],
    authFlow: true
  },

  product: {
    matchers: [PRODUCT_DETAILS_URL_MATCHER],
    paths: [
      'p/:name/:productCode',
      ':brand/p/:name/:productCode'
    ]
  },

  category: {
    matchers: [sisCategoryMatcher, PRODUCT_LISTING_URL_MATCHER],
    paths: ['c/:categoryCode']
  },

  recipeCategory: {
    matchers: [RECIPE_CATEGORY_URL_MATCHER],
    paths: ['crp/:recipeCategoryCode']
  }
};
